import React, { useContext, useEffect } from 'react';
import { AppContext, ToastrContext } from '../../contexts';
import { useLocation } from 'react-router-dom';
import DataTable from '../../components/elements/DataTable';
import { Badge, Flex, Paper, Stack, Text } from '@mantine/core';
import { thousand } from '../../utils/format';
import IconCheck from '../../components/icons/IconCheck';
import styles from './styles.scoped.css';
import IconClose from '../../components/icons/IconClose';
import IconReload from '../../components/icons/IconReload';
import Button from '../../components/elements/Button';
import IconDownload from '../../components/icons/IconDownload';
import { useDispatch, useSelector } from 'react-redux';
import { fetchListRequestStatusBulk, fetchRequestSummaryFile, fetchStatusBlockUnblock } from './action';
import dayjs from 'dayjs';

const LogStatus = () => {
  const location = useLocation();
  const statusType = location.pathname.split('/').pop();
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);

  const dispatch = useDispatch();

  const {
    listRequestStatusBulk
  } = useSelector((state) => state.nikManagement);

  const styleCus = {
    PROCESS: {
      bg: '#FFECE0',
      c: '#FF711A'
    },
    DONE: {
      bg: '#E0FFE3',
      c: '#44AB4A'
    },
    ON_PROCESS: {
      bg: '#E0F3FE',
      c: '#0F6EB5'
    },
    FAILED: {
      bg: '#FBE5E6',
      c: '#CF212A',
    }
  };

  const renderFileNameStatus =
    (data) => {
      const badges = [
        { value: data?.totalSuccess, status: 'DONE', text: 'Berhasil', icon: <IconCheck className={styles.iconCheck} /> },
        { value: data?.totalFailed, status: 'FAILED', text: 'Gagal', icon: <IconClose className={styles.iconClose} type="thin" /> },
        { value: data?.totalProcess, status: 'ON_PROCESS', text: 'Diproses', icon: <IconReload className={styles.iconReload} /> },
      ];
      return (
        <Stack gap="xs">
          <Text c="#52575C" fz={12}>{data?.summary?.fileName}</Text>
          <Flex align="center" gap="sm">
            {badges.map((item, idx) => {
              if (item.value === 0) return null;
              return (
                <Badge
                  bg={styleCus[item.status]?.bg} c={styleCus[item.status]?.c}
                  fw={500} key={idx}
                  tt="none">
                  <Flex align="center" gap="xs">
                    {item.icon}
                    <Paper bg="transparent" mt={2}>
                      {thousand(item?.value)} {item.text}
                    </Paper>
                  </Flex>
                </Badge>
              );
            })}
          </Flex>
        </Stack>
      );
    };

  const renderStatus = (data) => {
    const wordingStatus = {
      DONE: 'Selesai',
      PROCESS: 'Sedang Diproses'
    };
    return(
      <Badge bg={styleCus[data?.status]?.bg} c={styleCus[data?.status]?.c} fw={500}
        tt="none">{wordingStatus[data?.status] || 'Gagal'}</Badge>
    );
  };

  const responseDownloadHandler = (response) => {
    if (!response.success) {
      setToastr({
        visible: true,
        desc: 'Terjadi kesalahan saat mengunduh file',
        type: 'danger'
      });
    }
  };

  const handleDownloadFile = (data) => {
    dispatch(fetchRequestSummaryFile({ fileName: data?.failedDocument }, responseDownloadHandler));
  };

  const handleSyncStatus = (data) => {
    dispatch(fetchStatusBlockUnblock(data?.id));
  };


  const renderAction = (data) => {
    if (data?.totalProcess && data?.status === 'PROCESS') {
      return (
        <Button className={styles.btnActionTable}
          onClick={() => handleSyncStatus(data)}><IconReload/>Perbarui Status</Button>
      );
    } else if (data?.totalFailed && data?.status === 'DONE') {
      return (<Button className={styles.btnActionTable}
        onClick={() => handleDownloadFile(data)}><IconDownload />
        Unduh NIK Gagal {data?.actionType === 'unblock' ? 'Diaktivasi' : 'Diblokir'}</Button>);
    } else {
      return null;
    }
  };

  const columns = [
    {
      heading: 'Tanggal Pembaruan', value: (data) => data?.createdAt ?
        dayjs(data?.createdAt).locale('id').format('DD MMM YYYY | HH:mm') : '', className: ''
    },

    {
      heading: 'File dan Status NIK',
      value: renderFileNameStatus,
      className: '',
    },
    {
      heading: 'Status', value: renderStatus, className: ''
    },
    {
      heading: 'Tindakan', value: renderAction, className: ''
    },
  ];

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Blokir & Aktifkan NIK', to: '/customer-setting' },
      `Status Proses ${statusType === 'block' ? 'Blokir' : 'Aktivasi'} Data`
    ]);
    dispatch(fetchListRequestStatusBulk({ actionType: statusType, page: 1, size: 100 }));
  }, []);
  return (
    <div>
      <DataTable column={columns} data={listRequestStatusBulk?.data}
        loading={listRequestStatusBulk.isLoading} withIndex />
    </div>
  );
};

export default LogStatus;
